import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import NodeBasedHistory from '../components/actionMenu/NodeBasedHistory';

const PageContainer = styled.div`
  background: white;
  position: absolute; /* Position absolutely to escape ContentArea padding */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* Prevent outer scroll - child handles it */
`;

function CaseHistory() {
  const { loanId } = useParams();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <NodeBasedHistory 
        loanId={loanId} 
        useRealFields={true}
        showBackButton={true}
        onBackClick={() => navigate(`/document-analysis/${loanId}`)}
      />
    </PageContainer>
  );
}

export default CaseHistory;

